<template>
  <!-- 包裹解决im定位问题 -->
  <div class="layout-component" :class="className" @scroll="handleScroll">
    <el-container class="container">
      <el-header>
        <MainHeader />
      </el-header>
      <router-view />
      <slot></slot>
      <el-footer v-show="Footer" class="footer">
        <MainFooter />
      </el-footer>
    </el-container>
    <div class="im-container">
      <template>
        <zimPcMoveDialog>
          <div class="chatleft">
            <zim-pc-group-list
              @message-click="groupListMessageClick"
              :searchText="searchText"
              :userInfo="imUserInfo"
            ></zim-pc-group-list>
          </div>
          <div class="chat">
            <zim-pc-groupChat></zim-pc-groupChat>
          </div>
        </zimPcMoveDialog>
      </template>
    </div>
  </div>
</template>

<script>
import config from '@/const/config';
import zim, { zimApi, emojis, tools } from '@zyf2e/zim/lib/b2b';
import { zimPcGroupChat, zimPcGroupList, zimPcMoveDialog } from '@zyf2e/zim-ecology/lib/pc';
import '@zyf2e/zim-ecology/lib/pc.css';
import { buyer_creat_session, send_goods_message } from '@/services/chat';
import { ecologyEvent } from '@zyf2e/zim-ecology/lib/pcstore';
import { mapState, mapGetters, mapActions } from 'vuex';

import MainHeader from '@/components/MainHeader/index.vue';
import MainFooter from '@/components/MainFooter/index.vue';

export default {
  components: {
    MainHeader,
    MainFooter,
    zimPcGroupChat,
    zimPcGroupList,
    zimPcMoveDialog
  },
  data() {
    return {
      searchText: '用户名/药店名',
      className: { search_nav_scroll: false },
      imUserInfo: {
        avatar: '',
        name: ''
      }
    };
  },
  computed: {
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList',
      unReadMessageNum: 'imChatService/getUnReadMessageNum',
      Footer: 'layout/getFooter'
    }),
    ...mapState('USER', {
      userInfo: (state) => state.userInfo
    }),
    pageStyle() {
      // return this.$route.name === 'all' ? { overflow: 'scroll' } : { height: '100%', overflow: 'scroll' };
      // return this.$route.name === 'all' ? {} : { height: '100%' };
    }
  },
  async mounted() {
    console.warn('layout', this.Footer);
    await this.getUserInfo();
    this.eventInit();
    this.imServiceInit();
  },
  methods: {
    ...mapActions('USER', ['getUserInfo']),
    eventInit() {
      ecologyEvent.unsubscribe('imChatService.SEND_WAIT_CONFIG');
      ecologyEvent.subscribe('imChatService.SEND_WAIT_CONFIG', async (tag, arg) => {
        const { groupId, itemCode } = arg;
        send_goods_message({
          itemCode,
          groupId,
          terminalType: 'PC'
        });
      });
    },
    handleScroll(e) {
      if (e.target.scrollTop > 40) {
        this.className.search_nav_scroll = true;
      } else {
        this.className.search_nav_scroll = false;
      }
    },
    imServiceInit() {
      this.$store.commit('imDebugService/setDebug', true);
      const uid = this.userInfo?.userInfoVO?.userId || '';
      this.imUserInfo = {
        name: this.userInfo.userInfoVO.name,
        avatar: 'https://static.kminghealth.com/attachment/20210827152031607_6002367fd96047fe85aeb7d2a68cc3c5.png'
      };
      this.$store.dispatch('imService/setZIMLib', {
        zim,
        zimApi,
        emojis,
        tools
      });
      const zimEnvConfig = {
        uid,
        runtime: {
          env: 'H5',
          apigw: config.IMAPIGW
        },
        debug: true,
        db: true,
        zone: config.IM,
        origin: 'kminghealth.com',
        // reqHttp: true // TODO QA 调试 - 通过http请求
      };
      this.$store.commit('imService/SET_ZimConfig', {
        ...zimEnvConfig
      });
      this.$store.dispatch('imService/initIm', {
        uid
      });
      this.$store.dispatch('imInputService/SET_UseEmoj', true);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        // this.groupChat.init();
      });
      // this.openIm();
    },
    openIm() {
      this.$store.dispatch('imDialogService/openDialog');
    },

    openTargetChat() {
      const groupId = '859856320652288';
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.openIm();
    },
    async openNewChat() {
      const groupId = await buyer_creat_session({
        userId: '230214208135171'
      });
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.openIm();
    },
    groupListMessageClick({ groupId }) {
      this.$store.dispatch('imChatService/SET_CHAT_GID', String(groupId));
      this.$nextTick(() => {
        this.groupChat.init();
      });
    },
    goPersonalCenter() {
      this.$router.push('/personalCenter/index');
    },
    goHome() {
      this.$router.push('/mallHomePage/all');
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
.layout-component {
  height: 100%;
  width: 100%;
  overflow: auto;
}
.content {
  padding: 0;
}
.footer {
  height: auto !important;
  background: #eaeaea;
}

/deep/ .el-main {
  padding: 0;
}
/deep/ .el-header {
  padding: 0;
}
</style>
<style lang="scss">
.chatleft {
  width: 240px;
  overflow: scroll;
}
.chat {
  flex: 1;
  background: #fafafa;
  height: 100%;
}
</style>
